<template lang="pug">
include ../../utils/picture.pug
include ../../utils/icon-btn.pug
.plainform
  .plainform__content.trs
      h2.modal__title.t-h2.clr-blue-7 {{title}}
      form(
        @submit.prevent="formSubmit" name=some
        v-if="!isSuccess"
      ).js-form.modal__form
        component(
            v-for="item in fields"
            v-bind:is="getComponentByType(item.component)"
            v-model="updateField"
            :key="item.id"
            :item="item"
        )
        button.modal__submit.btn.btn--outline.btn-submit.clr-blue-10(
            type=`submit`
            data-text submit
            data-success= success
            v-bind:class="{ active: isSuccess }"
        ) {{sendText}}
        .form-error(v-if="errors.length") {{error}}
      .success-message(v-if="isSuccess" v-html="successText")
</template>

<script>
  import plainform from './formlogic.js'
  export default plainform
</script>
